export interface NextActionsDto {
  id: number;
  responsibleParty: ResponsiblePartyEnum;
  nextActionType: string;
  title: string;
  description: string;
  mailDescription: string;
  icon: string;
}

export enum ResponsiblePartyEnum {
  None = 'None',
  Customer = 'Customer',
  Installer = 'Installer',
  GridOperator = 'GridOperator'
}

export const ResponsiblePartyDisplayNames = {
  [ResponsiblePartyEnum.None]: 'Kein Verantwortlicher',
  [ResponsiblePartyEnum.Customer]: 'Kunde',
  [ResponsiblePartyEnum.Installer]: 'Installateur',
  [ResponsiblePartyEnum.GridOperator]: 'Netzbetreiber'
};

export type NextActionDetails = {
  title: string;
  description: string;
  mailDescription: string;
  isResponsible: boolean;
  actionUrl: string | null;
  icon: string | null;
};
